import { render, staticRenderFns } from "./Comment.vue?vue&type=template&id=44da0270&scoped=true&"
import script from "./Comment.vue?vue&type=script&lang=ts&"
export * from "./Comment.vue?vue&type=script&lang=ts&"
import style0 from "./Comment.vue?vue&type=style&index=0&id=44da0270&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44da0270",
  null
  
)

export default component.exports